const makeDistortionCurve = (sampleRate = 44100, amount = 50) => {
  const curve = new Float32Array(sampleRate)
  const deg = Math.PI / 180
  for (let i = 0; i < sampleRate; i++) {
    const x = (i * 2) / sampleRate - 1
    curve[i] = ((3 + amount) * x * 20 * deg) / (Math.PI + amount * Math.abs(x))
  }
  return curve
}

// inspired by https://voicechanger.io/voicemaker/transformers/anonymousTransformer.js
export const voiceDistortion = (stream: MediaStream) => {
  const oscilationFrequency = 20
  const distortion = 10

  const audioContext = new AudioContext()

  const inputNode = audioContext.createMediaStreamSource(stream)
  const outputNode = audioContext.createMediaStreamDestination()

  const waveShaper = audioContext.createWaveShaper()
  waveShaper.curve = makeDistortionCurve(44100, distortion)

  const oscillator = audioContext.createOscillator()
  oscillator.frequency.value = oscilationFrequency
  oscillator.type = 'sawtooth'

  const oscillatorGain = audioContext.createGain()
  oscillatorGain.gain.value = 0.005

  const delay = audioContext.createDelay()
  delay.delayTime.value = 0.01

  oscillator.start(0)
  oscillator.connect(oscillatorGain)
  oscillatorGain.connect(delay.delayTime)

  inputNode.connect(waveShaper)
  waveShaper.connect(delay)
  delay.connect(outputNode)

  return outputNode.stream
}
